import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

// import XLSX from 'xlsx'
// import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import general from '../../../modulos/general';

import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

// "use strict";

//Lista de Movimientos
const ListaDet = ({elemento, handleClickGesEgr}) => {
  return(
    <tr className=''>
      <td className='' style={elemento.procesado==="N"?{color: 'yellow'}:{color: '#FA7080'}}>{elemento.contrato}</td>
      <td className='' style={elemento.procesado==="N"?{color: 'yellow'}:{color: '#FA7080'}}>{elemento.fechaMov.substr(0, 10)}</td>
      <td className='' style={elemento.procesado==="N"?{color: 'yellow'}:{color: '#FA7080'}}>{elemento.procesado==="S"?"NO":"SI"}</td>
      <td className='' style={elemento.procesado==="N"?{color: 'yellow'}:{color: '#FA7080'}}>{elemento.descripcionServicio}</td>
      <td className='' style={elemento.procesado==="N"?{color: 'yellow'}:{color: '#FA7080'}}>{elemento.periodo}</td>
      <td className='' style={elemento.procesado==="N"?{color: 'yellow'}:{color: '#FA7080'}}>{elemento.origen}</td>
      <td className='' style={elemento.procesado==="N"?{color: 'yellow'}:{color: '#FA7080'}}>{general.formatNum(elemento.valorTotal.toString())}</td>

      <td className='center aligned'>
        <div className="ui vertical yellow animated button" tabIndex="0">
          <div className="hidden content" onClick={(ev)=>handleClickGesEgr(ev, elemento, "SI FACT")}>SI Fact</div>
          <div className="visible content">
            <i className="thumbs up icon" onClick={(ev)=>handleClickGesEgr(ev, elemento, "SI FACT")}></i>
          </div>
        </div>
      </td>
      <td className='center aligned'>
        <div className="ui vertical red animated button" tabIndex="0">
          <div className="hidden content" onClick={(ev)=>handleClickGesEgr(ev, elemento, "NO FACT")}>NO Fact</div>
          <div className="visible content">
            <i className="thumbs down icon" onClick={(ev)=>handleClickGesEgr(ev, elemento, "NO FACT")}></i>
          </div>
        </div>
      </td>

    </tr>
  )
};

const Lista = ({list, handleClickGesEgr}) => {
  const nivel1Detalle = list.map((elemento, i) => <ListaDet elemento={elemento} key={i}
    handleClickGesEgr={handleClickGesEgr}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// let argsBuscar = {tipoqry: `[{$match: {procesado: "N"}}]`}

// const argsBuscarCL = {numDocum: 2027}

class FactMF2 extends React.Component {
  state={argsDocum: {contrato: "", agno: "", mes: ""},
        opciones: "opcion1",
        listRtes: [], confirmaAct: false, open: false, errors: [], procBtn: 0, permiteBtn1: true}

  crudBD = async (operacionCRUD, args)=>{
//ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
//ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0])
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0])
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i])
    }
  }

  handleChange = async (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    let targetValue = ev.target.value
    const argsDocum = this.state.argsDocum
    if(ev.target.name==="opciones"){
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['agno'] = fechaFechaHoy.substr(0, 4)
      argsDocum['mes'] = fechaFechaHoy.substr(5, 2)

      this.setState({opciones: targetValue})
      this.setState({argsDocum})
      // this.setState({listRtes: []})
      this.handleSubmit(ev, this.state.opciones)
    }else{
      argsDocum[ev.target.name] = targetValue
      this.setState({argsDocum})
    }
  }

  handleNofact = async (ev)=>{
// console.log("1111")

    let errors = []
    if(!this.props.allMovRtesCC.allMovRtesCC){
      errors.push({path: "Movimientos", message: "Proceso de cargue de la información, por favor espere un momento..."});
    }

    this.setState({errors})
    if(errors.length===0){
      document.body.style.cursor = 'wait'

      let argsBuscar=""
      argsBuscar += `'procesado': 'N'`

      let listRtes = []

      argsBuscar = '{' + argsBuscar + '}'
      if(this.props.codigoCiudadUA==="Todas..."&&this.props.codigoDptoUA==="Todos..."){
        argsBuscar = {tipoqry: `[{$match: ${argsBuscar}},
          {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          {$sort: {contrato: 1, fechaMov: 1}}]`}
      }else{
        let match = ``
        if(this.props.codigoDptoUA!=="Todos..."){
          match += `'cliente.dirmayor.codigoDpto': '${this.props.codigoDptoUA}'`
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          if(match){
            match += `, `
          }
          match += `'cliente.dirmayor.ciudades.codigoCiudad': '${this.props.codigoCiudadUA}'`
        }
        argsBuscar = {tipoqry: `[{$match: ${argsBuscar}},
          {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          {$match: {${match}}},
          {$sort: {contrato: 1, fechaMov: 1}}]`}
      }

      // console.log(argsBuscar)
      let {data} = await this.props.allMovRtesCC.refetch(argsBuscar)
      if(data!==undefined){
        listRtes = await data.allMovRtesCC
      }

      if(listRtes.length===0){
        document.body.style.cursor = 'default'
      }
      for(let ii=0; ii<listRtes.length; ii++){
        if(listRtes[ii].cliente[0].estadoCliente==="RETIRADO" && listRtes[ii].cliente[0].saldoPendiente<=0){
          // console.log("NO facturar ", listRtes[ii].contrato)
          
          const response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = await response.data.fecha

          let actColecc = []
          let argsUpd = {
            "_id": listRtes[ii]._id,
            "tipoAct": "EditarMovFact",
          }
          argsUpd.procesado = "S"
          argsUpd.documento = "NO FACT"
          argsUpd.fechaNoFact = fechaHoraHoy
          argsUpd.usuarioNoFact = sessionStorage.getItem('userLogin')
          // console.log(argsUpd)
          actColecc.push(argsUpd)

  //GRABAR EN BD
          let numDocCRUD = 0
          let totDocCRUD = 1
          let argsCrud = []
          let crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editMovCliCC)
          }

          argsCrud[numDocCRUD] = actColecc[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editMovCliCC
      // console.log(crudColecc)
      // console.log(argsCrud)
      // console.log(totDocCRUD)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }
        if(ii===listRtes.length-1){
          document.body.style.cursor = 'default'

          // console.log(listRtes)
          this.handleSubmit(ev, this.state.opciones)
        }
      }

    }
    this.setState({permiteBtn1: true, open: false, confirmaAct: false})
  }

  handleSubmit = async (ev, opciones)=>{
    // console.log(ev.target.name)
    // console.log(this.state.argsDocum)
    // console.log(opciones)
    // document.body.style.cursor = 'wait'

    let errors = []
    if(!this.props.allMovRtesCC.allMovRtesCC){
      errors.push({path: "Movimientos", message: "Proceso de cargue de la información, por favor espere un momento..."});
    }

    this.setState({errors})
    if(errors.length===0){
      let argsBuscar=""
      if(opciones==="opcion1"){
        argsBuscar += `'procesado': 'N'`
      }
      if(opciones==="opcion2"){
        argsBuscar += `'procesado': 'S', 'documento': 'NO FACT', 'agno': '${this.state.argsDocum.agno}', 'mes': '${this.state.argsDocum.mes}'`
        // argsBuscar += `'procesado': 'S', 'documento': 'NO FACT'`
      }
      if(opciones==="opcion3"){
        argsBuscar += `$or: [{'procesado': 'N'}, {'procesado': 'S', 'documento': 'NO FACT', 'agno': '${this.state.argsDocum.agno}', 'mes': '${this.state.argsDocum.mes}'}]`
        // argsBuscar += `$or: [{'procesado': 'N'}, {'procesado': 'S', 'documento': 'NO FACT'}]`
      }

      let listRtes = []
    
      if(this.state.argsDocum.contrato){
        argsBuscar += `, 'contrato': '${this.state.argsDocum.contrato}'`
      }

      argsBuscar = '{' + argsBuscar + '}'
      if(this.props.codigoCiudadUA==="Todas..."&&this.props.codigoDptoUA==="Todos..."){
        argsBuscar = {tipoqry: `[{$match: ${argsBuscar}},{$sort: {contrato: 1, fechaMov: 1}}]`}
      }else{
        let match = ``
        if(this.props.codigoDptoUA!=="Todos..."){
          match += `'cliente.dirmayor.codigoDpto': '${this.props.codigoDptoUA}'`
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          if(match){
            match += `, `
          }
          match += `'cliente.dirmayor.ciudades.codigoCiudad': '${this.props.codigoCiudadUA}'`
        }
        argsBuscar = {tipoqry: `[{$match: ${argsBuscar}},
          {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          {$match: {${match}}},
          {$sort: {contrato: 1, fechaMov: 1}}]`}

      }

      // console.log(argsBuscar)
      let {data} = await this.props.allMovRtesCC.refetch(argsBuscar)
      if(data!==undefined){
        listRtes = await data.allMovRtesCC
      }
      this.setState({listRtes})
    }
    // document.body.style.cursor = 'default'

    // console.log("listooooo")
  }

  handleClickGesEgr = async (ev, elemento, accion)=>{
    // console.log(accion)
    // console.log(elemento)

    if((accion==="SI FACT"&&elemento.procesado==="S")||(accion==="NO FACT"&&elemento.procesado==="N")){

      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = await response.data.fecha

      let actColecc = []
      let argsUpd = {
        "_id": elemento._id,
        "tipoAct": "EditarMovFact",
      }
      if(accion==="SI FACT"){
        argsUpd.procesado = "N"
        argsUpd.documento = ""
        argsUpd.fechaNoFact = null
        argsUpd.usuarioNoFact = null
      }else{
        argsUpd.procesado = "S"
        argsUpd.documento = "NO FACT"
        argsUpd.fechaNoFact = fechaHoraHoy
        argsUpd.usuarioNoFact = sessionStorage.getItem('userLogin')
      }
      // console.log(argsUpd)
      actColecc.push(argsUpd)

  //GRABAR EN BD
      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editMovCliCC)
      }

      argsCrud[numDocCRUD] = actColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editMovCliCC
  // console.log(crudColecc)
  // console.log(argsCrud)
  // console.log(totDocCRUD)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)

      this.handleSubmit(ev, this.state.opciones)
      // await this.props.allMovRtesCC.refetch()
    }
  }

  handleQuestionUpdDel = async (ev, btn) => {
    // console.log(btn, this.state.open, this.state.confirmaAct, ev.target.attributes[0].value, this.state.procBtn)
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      // console.log("11")
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false})
    }else{
      // if(btnPress!=="Si"&&btnPress!=="No"){
      // console.log("22")
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
      // }
    };
    if(btnPress==="No"){
      // console.log("33")
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
    };
    if(btnPress==="Si"){
      // console.log("44")
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){
    if(this.props.allMovRtesCC.allMovRtesCC&&!prevProps.allMovRtesCC.allMovRtesCC){
      if(this.props.codigoCiudadUA==="Todas..."&&this.props.codigoDptoUA==="Todos..."){
        this.setState({listRtes: this.props.allMovRtesCC.allMovRtesCC})
      }else{
        let match = ``
        if(this.props.codigoDptoUA!=="Todos..."){
          match += `'cliente.dirmayor.codigoDpto': '${this.props.codigoDptoUA}'`
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          if(match){
            match += `, `
          }
          match += `'cliente.dirmayor.ciudades.codigoCiudad': '${this.props.codigoCiudadUA}'`
        }

        let listRtes = []

        let argsBuscar=""
        argsBuscar += `'procesado': 'N'`
  
        argsBuscar = '{' + argsBuscar + '}'
        argsBuscar = {tipoqry: `[{$match: ${argsBuscar}},
          {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
          {$match: {${match}}},
          {$sort: {contrato: 1, fechaMov: 1}}]`}
  
        // console.log(argsBuscar)
        if(this.props.allMovRtesCC.allMovRtesCC){
          let {data} = await this.props.allMovRtesCC.refetch(argsBuscar)
          if(data!==undefined){
            listRtes = await data.allMovRtesCC
          }
          this.setState({listRtes})  
        }
      }
    }
  }

  render(){
    const {opciones, listRtes, confirmaAct, errors, open, permiteBtn1} = this.state;

    // let mensaje1 = "NO facturar RETIRADOS con saldo <= 0 y total movim <= 0"
    let mensaje1 = "NO facturar clientes RETIRADOS con saldo menor o igual a cero"
    let imgIcon1 = "images/archivo_32.png"

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Movimientos a facturar
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            {/* <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, opciones):()=>{}}> */}

            <Form name="form1" id="form1" onSubmit={confirmaAct
            ?permiteBtn1
              ?(ev)=>this.handleNofact(ev)
                :()=>{}
            :()=>{}}>         

              <div>
              <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '30%'}}>
                      <h1 style={{color: '#2C7744'}}>Movimientos a facturar</h1>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Opciones&nbsp;&nbsp;&nbsp;</legend>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;SI Facturar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;NO Facturar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Todos</label>
                      </fieldset>
                    </div>
                    {/* <div className="column" style={{width: '20%'}}>
                      {argsDocum.estadoos==="CERRADA" &&
                        <div>
                          <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                            <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion4" defaultChecked="true" onChange={this.handleChange}></input>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                            <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion5" onChange={this.handleChange}></input>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Con cargos&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                            <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion6" onChange={this.handleChange}></input>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Con nueva tarifa</label>
                          </fieldset>
                        </div>
                      }
                    </div> */}
                  </div>
                </div>
                <hr></hr>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '10%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Contrato
                        </label>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '20%', paddingLeft: '0em', paddingRight: '0em'}}>
                      <Form.Field>
                        <Form.Input autoComplete="off" name="contrato" id="contrato" onChange={this.handleChange} placeholder='Contrato'/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '10%', paddingLeft: '0.2em', paddingRight: '0em', paddingTop: '0.1em'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, opciones)} fluid>
                        Buscar
                      </Button>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <hr></hr>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '29%', paddingLeft: '1.2em'}}>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Total Movimientos: {listRtes.length}
                    </p>
                    </div>
                    <div className="column" style={{width: '51%', paddingTop: '0.3em'}}>
                      <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                        open={open}
                        styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                    </div>
                  </div>
                </div>

                <hr></hr>
                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Contrato</th>
                        <th className=''>Fecha</th>
                        <th className=''>Facturar</th>
                        <th className=''>Servicio</th>
                        <th className=''>Periodo</th>
                        <th className=''>Origen</th>
                        <th className=''>Valor</th>
                        <th className='' style={{width: '10%'}}>SI Fact</th>
                        <th className='' style={{width: '10%'}}>NO Fact</th>
                      </tr>
                    </thead>
                    <Lista list={listRtes} handleClickGesEgr={this.handleClickGesEgr}/>
                  </table>
                </div>
              </div>
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allMovRtesCC, {name:'allMovRtesCC',options: (props) =>
    {return {variables: {tipoqry: `[{$match: {procesado: "N"}},{$sort: {contrato: 1, fechaMov: 1}}]`}}}}),

  graphql(queries.mutation.editMovCliCC, {name:'editMovCliCC'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(FactMF2)
